module.exports = __webpack_public_path__ + "img/modelGreen.b682c745.jpg";